import React, {useCallback, useEffect} from 'react';
import * as S from './LineLoader.styles';
import Icon from '../IconsSelector';

type LineLoaderProps = {
  width?: string;
  height?: string;
};

const LineLoader = ({width, height = '1.6rem'}: LineLoaderProps) => {
  return <S.LineLoader width={width} height={height}></S.LineLoader>;
};

export default LineLoader;
